module.exports = __webpack_public_path__ + "img/OFFLINEPAY2x.png?bf619dc5f83b4c1a177455246f54c99c";